import React from 'react';
import { Link } from 'react-router-dom';
import Button from '@material-ui/core/Button';
import { withTheme } from '@material-ui/core/styles';
import { TextString } from './Text';

const MyLink = React.forwardRef((props, ref) => (
  <Link
    innerRef={ref}
    to={props.targetURL ? props.targetURL : props.to}
    {...props}
  />
));

/**
 * @deprecated
 */
function ButtonLink({ content, children, ...props }) {
  return (
    <Button component={MyLink} {...props}>
      {content ? <TextString content={content} /> : children}
    </Button>
  );
}

export default withTheme(ButtonLink);
